// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3NVus","signatureButtonsRight":"ModalSign_signatureButtonsRight__1zlud"};